<template>
    <div class="centerPage">
        <div class="pageTit">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/admin/dict/list'}">字典管理</el-breadcrumb-item>
                <el-breadcrumb-item>字典编辑</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-collapse :value="editId?'2':'1'" accordion>
            <el-collapse-item title="字典编辑" name="1" >
                <el-form ref="form" class="article_edit">
                    <el-form-item label="字典名称：">
                        <el-input v-model="editData.dictName" style="width: 1000px" placeholder="请输入字典名称">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="字典代码：">
                        <el-input v-model="editData.dictCode" style="width: 1000px" placeholder="请输入字典代码">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="类型：">
                        <el-radio-group v-model="editData.dictType" class="type">
                            <el-radio :label="1">可编辑</el-radio>
                            <el-radio :label="0">不可编辑</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="字典描述：">
                        <el-input v-model="editData.dictDesc" style="width: 1000px" placeholder="请输入字典描述" :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="editData.remark" style="width: 1000px" placeholder="请输入备注" :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
                        </el-input>
                    </el-form-item>
                    <div class="btn">
                        <el-button @click="toUpdate" v-if="editId">更新</el-button>
                        <el-button @click="toSave" v-else>添加</el-button>
                    </div>
                </el-form>
            </el-collapse-item>
            <el-collapse-item title="二级字典表" name="2" v-if="editId">
                <el-button @click="toEdit(0)">
                    添加
                </el-button>
                <template>
                    <el-table
                            :data="listData.filter(data => !search || data.itemName.toLowerCase().includes(search.toLowerCase()))"
                            stripe
                            style="width: 100%">
                        <el-table-column
                                prop="id"
                                label="id"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="itemName"
                                label="字典名称"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="itemCode"
                                label="字典代码"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="itemType"
                                label="类型">
                            <template slot-scope="scope">
                                <span v-if="scope.row.dictType === 0" style="color: orangered">可编辑</span>
                                <span v-else-if="scope.row.dictType === 1" style="color: #56C147">不可编辑</span>
                                <span v-else>无数据</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status === 0" style="color: orangered">封禁</span>
                                <span v-else-if="scope.row.status === 1" style="color: #56C147">正常</span>
                                <span v-else>无数据</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="haveSubItem"
                                label="子项">
                            <template slot-scope="scope">
                                <span v-if="scope.row.haveSubItem === 0" style="color: orangered">无</span>
                                <span v-else-if="scope.row.haveSubItem === 1" style="color: #56C147">有</span>
                                <span v-else>无数据</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="itemDesc"
                                label="字典描述">
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                label="备注">
                        </el-table-column>
                        <el-table-column
                                align="right"
                                width="250">
                            <template slot="header" slot-scope="scope">
                                <el-input
                                        v-model="search"
                                        :data-solveBug="scope"
                                        size="mini"
                                        placeholder="输入关键字搜索"/>
                            </template>
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger" @click="toDelete(scope.row.id)">删除</el-button>
                                <el-button @click="toEdit(scope.row.id)" size="mini" type="info">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>
    import commonjs from "../../../api/common";
    export default {
        name: "catalogEdit",
        data() {
            return {
                editData: {
                    dictCode: "",
                    dictDesc: "",
                    dictName: "",
                    dictType: "",
                    id: "",
                    remark: "",
                },
                editId: this.$route.query.id,

                listData: [],
                search: '',
            }
        },
        mounted() {
            if (this.editId != null) {
                this.getEditData();
                this.getListData();
            }
        },
        methods: {
            getEditData() {
                let that = this;
                this.$ajax
                    .get(commonjs.api.dict.edit.detail.replace("{id}",this.editId))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                            that.editData = res.data.data;
                        } else {
                            that.$message.error(res.data.message);
                            that.$router.push({name: 'catalogList_admin'});
                        }
                    })
            },
            toSave() {
                let that = this;
                this.$ajax
                    .post(commonjs.api.dict.edit.save,this.editData)
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.$message.success('操作成功');
                        that.$router.push({name: 'catalogList_admin'});
                      } else {
                        that.$message.error(res.data.message);
                      }
                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败');
                })
            },
            toUpdate() {
                let that = this;
                this.$ajax
                    .post(commonjs.api.dict.edit.update,this.editData)
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.$message.success('操作成功');
                        that.$router.push({name: 'catalogList_admin'});
                      } else {
                        that.$message.error(res.data.message);
                      }
                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败');
                })
            },
            getListData() {
                let that = this;
                this.$ajax
                    .get(commonjs.api.dict.edit.item.list.replace("{catalogId}",this.editId))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                            that.listData = res.data.list;
                        }
                    })
            },
            // toDelete(id) {
            //     let that = this;
            //     this.$confirm('如果只是想暂时下架字典二级表字段,可禁用', '确认删除?', {
            //         confirmButtonText: '删除',
            //         cancelButtonText: '不删了',
            //         type: 'warning'
            //     }).then(() => {
            //         this.$ajax
            //             .delete(commonjs.api.dict.edit.item.delete.replace("{id}",id))
            //             .then(function (res) {
            //               if (res.data.status === 'success') {
            //                 that.$message.success('操作成功');
            //                 that.getListData();
            //               } else {
            //                 that.$message.error(res.data.message);
            //               }
            //             }).catch((err) => {
            //           console.error(err);
            //           that.$message.error('操作失败');
            //         })
            //     }).catch(() => {
            //         this.$message.info('已取消删除');
            //     });
            // },
            toEdit(id) {
                if (id===0) {
                    this.$router.push({name: 'dictItemEdit',query: {catalogId: this.editData.id}})
                } else {
                    this.$router.push({name: 'dictItemEdit',query: {catalogId: this.editData.id,id: id}})
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../assets/css/banner.scss';

    .centerPage {
        display: block;
    }
</style>